/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;

	export class Loading extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(jQuery('#loading'));

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			Loading.instance = this;

			return this.getView();
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'block');
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'none');
			});
		}





		public static show(useTransition:boolean = true):void {
			this.instance.show(useTransition);
		};

		public static hide(useTransition:boolean = true):void {
			this.instance.hide(useTransition);
		};





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private static instance:Loading = null;
	}
}
